import axios from 'axios';
import Config from '../config';
import { BigNumber, randomSleep } from './helper';
import baseInfo from "../mock/baseInfo";
import voteList from "../mock/voteList";
import voteStatus from "../mock/voteStatus";

const { service, yielders } = Config;
const {
    host,
    marketsPath,
    userPath,
    dashboardPath,
    jtokenDetailsPath,
    govPath,
    proposalListPath,
    voteStatusPath,
    basePath,
    tronLinkHost,
    balancePath,
    getTime,
    yieldInfos,
    tronBull,
    tronbullish
} = service;
export const getTrxPrice = async () => {
    try {
        let url = `${Config.trxPriceUrl}`;
        let { data } = await axios.get(url);
        const { TRX } = data.data;
        const price = TRX.quote.USD.price;

        return {
            success: true,
            price: BigNumber(price)
        };
    } catch (error) {
        await randomSleep();
        return await getTrxPrice();
    }
};

export const getMarketData = async () => {
    try {
        let url = `${host}${marketsPath}`;
        let { data } = await axios.get(url);

        return {
            success: true,
            data: data.data
        };
    } catch (error) {
        return {
            success: false
        };
    }
};

export const getMarketDashboardData = async () => {
    try {
        let url = `${host}${marketsPath}${dashboardPath}`;
        let { data } = await axios.get(url);
        return {
            success: true,
            data: data.data
        };
    } catch (error) {
        console.log(error);
        await randomSleep();
        return await getMarketDashboardData();
    }
};

export const getJTokenDetails = async jtokenAddr => {
    try {
        let url = `${host}${marketsPath}${jtokenDetailsPath}`;
        let { data } = await axios.get(url, { params: { jtokenAddr } });
        return {
            success: true,
            data: data.data
        };
    } catch (error) {
        console.log(error);
        await randomSleep();
        return await getJTokenDetails();
    }
};

export const getTotalVoted = async contractAddr => {
    try {
        let url = `${backend.host}${backend.vote}`;
        let { data } = await axios.get(url, { params: { contractAddr } });
        return {
            success: !!data.data.collateralSymbol,
            data: data.data
        };
    } catch (error) {
        return {
            success: false
        };
    }
};

export const getVoteList = async block => {
    try {
        // let url = `${host}${govPath}${proposalListPath}`;
        // let { data } = await axios.get(url, { params: { block } });
        let proposalList = [];
        const data = voteList;
        let proposal = null;
        try {
            if(window.tronWeb && window.tronWeb.ready) {
                const contractInstance = await window.tronWeb.contract().at(Config.contract.governorAlphaAddress);
                const feedback = await contractInstance.proposals(Config.newProposalId).call();
                const proposalState = await contractInstance.state(Config.newProposalId).call();
                const { againstVotes, forVotes, startBlock, endBlock, canceled } = feedback;
                proposal = {
                    "canceled": canceled,
                    "activeTime": 1677044175000,           // 开始时间
                    "againstVotes": parseInt(againstVotes),
                    "cancelTime": null,
                    "content": null,
                    "endBlock": 33049285,
                    "endTime": 1677303375000,           // 结束时间
                    "executedTime": 1629854583000,
                    "executedTxid": "7931ad496efb815ab71ba5f189c5264261d6d17a0bfaef54f126ac46d1a895a0",
                    "forVotes": parseInt(forVotes),
                    "id": Config.newProposalShowId,
                    "note": "0000000000000000000000000000000000000000000000000000000000000003000000000000000000000000576335cd57ee7ebc9c1b807208c3b5b769be8c4a0000000000000000000000000000000000000000000000000000000000000120000000000000000000000000000000000000000000000000000000000000016000000000000000000000000000000000000000000000000000000000000001a000000000000000000000000000000000000000000000000000000000000002200000000000000000000000000000000000000000000000000000000001f6f9450000000000000000000000000000000000000000000000000000000001f84ac500000000000000000000000000000000000000000000000000000000000002a000000000000000000000000000000000000000000000000000000000000000010000000000000000000000003dfe637b2b9ae4190a458b5f3efc1969afe278190000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000010000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001262616c616e63654f6628616464726573732900000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000002000000000000000000000000000000000000000000000000000000000000000200000000000000000000000003dfe637b2b9ae4190a458b5f3efc1969afe27819000000000000000000000000000000000000000000000000000000000000000f4150454e46542050726f706f73616c0000000000000000000000000000000000",
                    "proposalId": Config.newProposalId,
                    "proposeTxid": "69ef3601f31382c029b39ed701b7d80d4f0dd0c623a698f16c2452534a70f4ba",
                    "proposer": "THwGdzT54qzyobejRKsUtWGgynyUEnM3Vy",
                    "queuedTime": 1629854583000,
                    "queuedTxid": "36ed362072429dab66967507f3a79bff7b9c208e8b3011543867d1f210d9bbca",
                    "state": proposalState,
                    "title": null
                }
                data.data.proposalList[0] = proposal;   
            }
        } catch {
            console.error('get proposals error');
        }
        if (data.code === 0 || data.message === 'SUCCESS') {
            proposalList = data.data.proposalList.filter(item => item.state !== -1);
            return {
                success: true,
                proposalList: proposalList
            };
        } else {
            await randomSleep();
            let block = await this.rootStore.lend.getCurrentBlock();
            return await getVoteList(block);
        }
    } catch (error) {
        await randomSleep();
        let block = await this.rootStore.lend.getCurrentBlock();
        return await getVoteList(block);
    }
};

export const getUserDetail = async (account, block) => {
    try {
        // let url = `${host}${govPath}${voteStatusPath}`;
        // let { data } = await axios.get(url, { params: { account, block } });
        const data = voteStatus;
        return {
            success: true,
            data: data.data
        };
    } catch (error) {
        await randomSleep();
        return await getUserDetail(account);
    }
};

export const getUserData = async params => {
    try {
        const confs = [];
        yielders.map(t => {
            confs.push(`${t.pool}$${t.sunSupply}$${t.day}`);
        });
        const config = confs.join(',');
        let url = `${host}${userPath}`;
        let { data } = await axios.get(url, { params: Object.assign(params, { config }) });
        return {
            success: true,
            data: data.data
        };
    } catch (error) {
        console.log(error, 'err');
        return {
            success: false
        };
    }
};

export const getBaseInfo = async (params = {}) => {
    try {
        // let url = `${host}${basePath}`;
        // let { data } = await axios.get(url, { params });
        // if (Number(data.code) !== 0) {
        //   return {
        //     success: false
        //   };
        // }
        const data = baseInfo;
        return {
            success: true,
            number: data.data.blockNum,
            timestamp: data.data.blockTimeStamp
        };
    } catch (error) {
        console.log('getBaseInfo: ', error);
        return {
            success: false
        };
    }
};

export const getTimeNow = async (params = {}) => {
    try {
        // let url = `${host}${getTime}`;
        // let { data } = await axios.get(url, { params });
        // if (Number(data.code) !== 0) {
        //     return {
        //         success: false
        //     };
        // }
        const data = baseInfo;
        return {
            success: true,
            time: Number(data.data.serverTimeStamp)
        };
    } catch (error) {
        console.log('getBaseInfo: ', error);
        return {
            success: false
        };
    }
};

export const getMintInfo = async addr => {
    try {
        const confs = [];
        yielders.map(t => {
            if (window.multyStart) {
                t.sunSupply = 0;
            }
            confs.push(`${t.pool}$${t.sunSupply}$${t.day}`);
        });
        const config = confs.join(',');
        const url = `${host}${yieldInfos}`;
        const { data } = await axios.get(url, { params: { addr, config } });
        return data.data ? { success: true, data: data.data } : { success: false };
    } catch (error) {
        console.log(`getMintInfo error: ${error}`);
        return { success: false };
    }
};

export const getTronBull = async (pool, tvl) => {
    try {
        const url = `${host}${tronBull}`;
        const { data } = await axios.get(url, { params: { pool, tvl } });
        return {
            success: !!data.data,
            data: data.data
        };
    } catch (error) {
        console.log(`getTronBull error: ${error}`);
        return { success: false };
    }
};

export const getTronbullish = async (pool, addr) => {
    try {
        const url = `${host}${tronbullish}`;
        const { data } = await axios.get(url, { params: { pool, addr } });
        return {
            success: !!data.data,
            data: data.data
        };
    } catch (error) {
        console.log(`getTronbullish error: ${error}`);
        return { success: false };
    }
};
